import { styled } from '@mui/material/styles'
import { ButtonWithTooltip } from '../../Buttons'

interface StyledDownloadStatementBtnProps {
  isLimitedAccess?: boolean
}

export const StyledDownloadStatementBtn = styled(ButtonWithTooltip, {
  shouldForwardProp: (prop) => prop !== 'isLimitedAccess',
})<StyledDownloadStatementBtnProps>(({ theme, isLimitedAccess }) => ({
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
  },
  margin: 0,
  [theme.breakpoints.down('sm')]: {
    width: isLimitedAccess ? '100%' : 'auto',
    marginTop: 0,
  },
  '& .MuiButton-root': {
    padding: 8,
    caretColor: 'transparent',
  },
  '& button': {
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}))
